// extracted by mini-css-extract-plugin
module.exports = {"button":"rating-field_button__4iMm9","selected":"rating-field_selected__KJl4s"};